import { render, staticRenderFns } from "./BookRequestSearch.vue?vue&type=template&id=0b86ec5e&scoped=true"
import script from "./BookRequestSearch.vue?vue&type=script&lang=js"
export * from "./BookRequestSearch.vue?vue&type=script&lang=js"
import style0 from "./BookRequestSearch.vue?vue&type=style&index=0&id=0b86ec5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b86ec5e",
  null
  
)

export default component.exports